module.exports = __webpack_public_path__ + "img/tooltip-phone.88ffbff2.png";